(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saiko-cart-complement"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('saiko-cart-complement')) return;

  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const ignored = new Set(('figurine figure figur figures figurines statue statuette poster posters affiche banniere bannieres banner banners wall hanging lampe lamp light led veilleuse porte cles cle clefs keychain keyring schlusselanhanger shirt tshirt tee t shirt sweat hoodie pull veste jacket tasser mug tasse sticker stickers pin pins badge magnet aimant marque page bookmark decoration decorations deko goodies accessoire accessoires anime manga collection set lot pack limited edition version style design kawaii chibi wanted bounty premium officiel official oversize coton cotton taille size model modele color couleur black white noir blanc noirblanc rouge red bleu blue green vert mini grand petit avec sans pour les des une un the and with for der die das mit von und roronoa monkey uchiha uzumaki kamado ackerman jaeger yeager son').split(' '));
  const aliases = new Map([
    ['dbz', 'dragon ball z'], ['dragonball z', 'dragon ball z'],
    ['l attaque des titans', 'attack on titan'], ['attaque des titans', 'attack on titan'], ['shingeki no kyojin', 'attack on titan'],
    ['kimetsu no yaiba', 'demon slayer'], ['boku no hero academia', 'my hero academia']
  ]);
  const animeKey = value => aliases.get(normalize(value)) || normalize(value);
  const tokenize = value => normalize(value).split(' ').filter(word => word.length >= 3 && !ignored.has(word) && !/\d/.test(word));
  ('gear wano dressrosa combat warrior guerre guerrier fire kick tornado monster point boxpack pvc resin resine acrylic pink rose purple violet yellow jaune orange brown marron silver argent gold dore beige framed unframed cadre cadres frame mount mounted').split(' ').forEach(word => ignored.add(word));
  ('coussin cushion kissen housse pillow peluche plush pluesch plueschtier sac bag tasche posterwand articulable articule articulee articulated action collector collectible collection statuettes figur neon acrylique acrylic bois wooden wood canvas toile painting small medium large extra regular slim short long manches sleeve sleeves sleeveless homme femme enfant men women kids boy girl box boite boites boitecarton sansboite without boxpack original soft cotton polyester blackwhite default title size taille noir gris grey gray white light dark usb plug prise europe eu uk us pack standard modele model version colorful multicolor multicolore').split(' ').forEach(word => ignored.add(word));
  const tagValues = (product, prefixes) => (product.tags || []).flatMap(tag => {
    const position = String(tag).indexOf(':');
    return position > 0 && prefixes.includes(normalize(tag.slice(0, position))) ? [tag.slice(position + 1).trim()] : [];
  });
  const context = (product, preferVariant = false) => {
    const parts = String(product.title || '').split(/[|｜]/);
    const anime = tagValues(product, ['anime', 'licence', 'license']);
    if (!anime.length && parts.length > 1) anime.push(parts.at(-1).trim());
    const universes = anime.map(animeKey).filter(value => value && !['anime', 'manga', 'pop culture', 'manga anime'].includes(value));
    const explicit = tagValues(product, ['personnage', 'character']);
    const name = parts[0].replace(/["«»“”]/g, ' ');
    const variantWords = product.variantTitle === 'Default Title' ? [] : tokenize(product.variantTitle);
    const characterText = preferVariant && variantWords.length ? variantWords.join(' ') : explicit.length ? explicit.join(' ') : name;
    const universeWords = new Set(universes.join(' ').split(' '));
    return { universes, characters: [...new Set(tokenize(characterText).map(word => word === 'zorro' ? 'zoro' : word === 'sanjii' ? 'sanji' : word).filter(word => !universeWords.has(word)))], query: anime[0] || '' };
  };
  const kind = product => {
    const text = ` ${normalize(`${product.handle} ${product.type} ${product.title}`)} `;
    for (const [name, pattern] of [
      ['keychain', /\b(porte cle[fs]*|porte cles|keychain|keyring|schlusselanhanger)\b/],
      ['poster', /\b(poster[s]?|affiche[s]?|kunstdruck|banniere[s]?|banner[s]?|wall hanging)\b/],
      ['sticker', /\b(sticker[s]?|autocollant[s]?)\b/],
      ['pin', /\b(pin[s]?|badge|broche)\b/],
      ['magnet', /\b(magnet|aimant)\b/],
      ['bookmark', /\b(marque page|bookmark|lesezeichen)\b/],
      ['patch', /\b(patch|ecusson)\b/],
      ['mug', /\b(mug|tasse)\b/],
      ['lamp', /\b(lampe|lamp|veilleuse)\b/],
      ['cushion', /\b(coussin|cushion|kissen|pillow|housse)\b/],
      ['plush', /\b(peluche|plush|pluesch|plueschtier)\b/],
      ['bag', /\b(sac|bag|tasche)\b/],
      ['figure', /\b(figurine[s]?|figure[s]?|statue|statuette)\b/],
      ['clothing', /\b(shirt|sweat|hoodie|pull|veste|vetement[s]?|maillot|jacket)\b/],
      ['goodie', /\bgoodies\b/]
    ]) if (pattern.test(text)) return name;
    return '';
  };
  const family = category => category === 'figure' ? 'figure' : category === 'clothing' ? 'clothing' : ['poster', 'lamp', 'cushion', 'decoration'].includes(category) ? 'decoration' : 'goodie';
  const tie = (source, product) => {
    let value = 2166136261;
    for (const letter of `${source}:${product}`) value = Math.imul(value ^ letter.charCodeAt(0), 16777619);
    return (value >>> 0) / 4294967296;
  };
  const purchasable = variant => variant?.available && !variant.requires_selling_plan && (variant.quantity_rule?.min || 1) <= 1 && (variant.quantity_rule?.increment || 1) <= 1 && (variant.quantity_rule?.max == null || variant.quantity_rule.max >= 1) && Number(variant.price) > 0;

  class SaikoCartComplement extends HTMLElement {
    static state = { busy: false, sourceId: null, notice: null, pending: null, blocked: new Set(), cache: new Map(), products: new Map(), choices: new Map() };
    static instances = new Set();
    static hooking = false;

    connectedCallback() {
      this.lifecycle = new AbortController();
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.headerFitFrame);
      this.headerObserver?.disconnect();
      this.lifecycle?.abort();
      this.readController?.abort();
      clearTimeout(this.noticeTimer);
      SaikoCartComplement.instances.delete(this);
    }

    initialize() {
      if (!this.isConnected) return;
      try { this.config = JSON.parse(this.dataset.config); } catch { return; }
      this.card = this.querySelector('[data-card]');
      this.grid = this.querySelector('[data-grid]');
      this.template = this.querySelector('template');
      this.status = this.querySelector('[data-status]');
      this.refreshButton = this.querySelector('[data-refresh]');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.card || !this.grid || !this.template || !this.status || !this.refreshButton) return;
      this.items = new Map();
      SaikoCartComplement.instances.add(this);
      const options = { signal: this.lifecycle.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-add]');
        if (button) this.add(Number(button.closest('[data-item]').dataset.productId));
      }, options);
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-variants]');
        if (select) this.selectVariant(Number(select.closest('[data-item]').dataset.productId), Number(select.value));
      }, options);
      this.refreshButton.addEventListener('click', () => this.recover(), options);
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.grid.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
      this.closest('cart-drawer')?.addEventListener('drawer:open', () => this.updateNavigation(), options);
      this.setupEvents();
      const brand = this.querySelector('.saiko-cart-complement__brand');
      this.lastHeaderWidth = null;
      if (brand && 'ResizeObserver' in window) {
        this.headerObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width === this.lastHeaderWidth) return;
          this.lastHeaderWidth = width;
          this.fitHeader();
        });
        this.headerObserver.observe(brand);
      }
      window.addEventListener('resize', () => this.fitHeader(), { ...options, passive: true });
      document.fonts?.ready.then(() => this.fitHeader());
      this.fitHeader();
      queueMicrotask(() => this.load());
    }

    fitHeader() {
      cancelAnimationFrame(this.headerFitFrame);
      if (!this.isConnected) return;
      this.headerFitFrame = requestAnimationFrame(() => {
        if (!this.isConnected || this.hidden || this.card?.hidden) return;
        const brand = this.querySelector('.saiko-cart-complement__brand');
        const heading = this.querySelector('.saiko-cart-complement__heading');
        const mark = this.querySelector('.saiko-cart-complement__mark');
        if (!brand || !heading || !mark || !brand.clientWidth) return;
        heading.style.removeProperty('--complement-heading-fit');
        const available = brand.clientWidth - mark.getBoundingClientRect().width - (parseFloat(getComputedStyle(brand).columnGap) || 0) - 1;
        if (available <= 0) return;
        const range = document.createRange();
        range.selectNodeContents(heading);
        const width = range.getBoundingClientRect().width;
        if (width > available) {
          const size = parseFloat(getComputedStyle(heading).fontSize);
          const fitted = Math.max(10, Math.floor((size * available / width - 0.15) * 10) / 10);
          heading.style.setProperty('--complement-heading-fit', `${fitted}px`);
        }
      });
    }

    setupEvents() {
      if (SaikoCartComplement.hooking) return;
      SaikoCartComplement.hooking = true;
      customElements.whenDefined('cart-items').then(() => {
        const bus = window.theme?.pubsub;
        if (!bus) return;
        bus.subscribe(bus.PUB_SUB_EVENTS.cartUpdate, event => {
          const state = SaikoCartComplement.state;
          if (!event?.cart?.items || event.cart.errors) return;
          if (event.source !== 'saiko-cart-complement') {
            const added = event.productVariantId && event.cart.items.find(item => String(item.variant_id) === String(event.productVariantId));
            if (added) { state.sourceId = Number(added.product_id); state.notice = null; }
          }
          queueMicrotask(() => SaikoCartComplement.instances.forEach(instance => instance.load()));
        });
      });
    }

    static rank(products, source, cartIds, cartItems = [source]) {
      const origin = context(source, true);
      if (!origin.universes.length) return [];
      const sourceKind = kind(source);
      const cartContext = cartItems.filter(item => !item.excluded).map(item => ({ ...context(item, true), category: kind(item) }));
      const unique = new Map();
      for (const product of products) {
        const before = unique.get(Number(product.id));
        unique.set(Number(product.id), { ...before, ...product, manualComplement: Boolean(before?.manualComplement || product.manualComplement), shopifyRelated: Boolean(before?.shopifyRelated || product.shopifyRelated) });
      }
      return [...unique.values()].flatMap(product => {
        if (!product.available || cartIds.has(Number(product.id)) || !product.image || !product.variantId || product.giftCard) return [];
        if (!Number.isFinite(product.price) || product.price <= 0) return [];
        if (product.requiresSellingPlan || product.minimum > 1 || product.increment > 1 || (product.maximum != null && product.maximum < 1)) return [];
        if ((product.tags || []).some(tag => normalize(tag) === 'saiko no upsell')) return [];
        const target = context(product);
        if (!target.universes.some(value => origin.universes.includes(value))) return [];
        const category = kind(product);
        if (!category) return [];
        const matches = origin.characters.filter(word => target.characters.includes(word));
        const sameCharacter = matches.length > 0;
        const redundant = cartContext.some(item => item.category === category && item.universes.some(value => target.universes.includes(value)) && item.characters.some(word => target.characters.includes(word)));
        if (redundant) return [];
        if (category === 'figure' && sourceKind === 'figure' && !target.characters.length) return [];
        const ratio = product.price / Math.max(Number(source.price) || 1, 1);
        const budget = ratio <= 0.65 ? 18 : ratio <= 1 ? 10 : ratio <= 1.5 ? 0 : -Math.min(40, 18 * Math.log2(ratio));
        const crossCategory = category !== sourceKind;
        const score = 40 + (crossCategory ? 30 : 0) + (sameCharacter ? 45 : 0) + budget
          + (product.manualComplement ? 30 : product.shopifyRelated ? 12 : 0)
          - (category === 'poster' ? 12 : 0) - (category === 'clothing' ? 8 : 0)
          - (product.variantsCount > 1 ? 3 : 0) + tie(source.id, product.id) * 2;
        return [{ ...product, category, family: family(category), characterMatch: sameCharacter, crossCategory, priceRatio: ratio, companionFigure: sourceKind === 'figure' && category === 'figure' && !sameCharacter, score }];
      }).sort((a, b) => b.score - a.score);
    }

    static select(products, source, cartIds, cartItems = [source]) {
      const ranked = this.rank(products, source, cartIds, cartItems);
      const selected = [];
      const categories = new Set();
      const families = new Set();
      const bands = new Set();
      const band = product => product.priceRatio <= 0.35 ? 0 : product.priceRatio <= 0.75 ? 1 : 2;
      const take = predicate => {
        const eligible = ranked.filter(product => !categories.has(product.category) && predicate(product));
        const score = product => product.score + (families.has(product.family) ? 0 : 12) + (bands.has(band(product)) ? 0 : 5);
        eligible.sort((a, b) => score(b) - score(a));
        const chosen = eligible[0];
        if (!chosen) return false;
        selected.push(chosen); categories.add(chosen.category); families.add(chosen.family); bands.add(band(chosen));
        return true;
      };
      take(product => product.crossCategory && product.category !== 'figure');
      take(product => product.crossCategory && product.category !== 'figure');
      if (kind(source) === 'figure') take(product => product.companionFigure);
      while (selected.length < 4 && take(() => true)) {}
      return selected;
    }

    source() {
      const items = this.config.items.filter(item => !item.excluded);
      return items.find(item => Number(item.id) === SaikoCartComplement.state.sourceId) || items[0];
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const external = options.signal;
      const abort = () => controller.abort();
      if (external?.aborted) controller.abort();
      external?.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(abort, options.timeout || (options.method === 'POST' ? 20000 : 10000));
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        if (!response.ok) { const error = new Error('Request failed'); error.status = response.status; throw error; }
        return options.asText ? await response.text() : await response.json();
      } finally { clearTimeout(timer); external?.removeEventListener('abort', abort); }
    }

    endpoint(path) { return `${this.config.root.replace(/\/?$/, '/')}${path}`; }

    async candidates(query, signal) {
      const key = `${this.config.locale}|${this.config.currency}|${query}`;
      const cache = SaikoCartComplement.state.cache;
      const saved = cache.get(key);
      if (saved && Date.now() - saved.time < 60000) return saved.products;
      const url = new URL(this.config.searchUrl, location.origin);
      url.search = new URLSearchParams({ q: query, type: 'product', section_id: 'saiko-cart-complement-data', sort_by: 'relevance', 'options[unavailable_products]': 'hide', 'options[prefix]': 'none' });
      const text = await this.request(url, { signal, asText: true, timeout: 5000 });
      const page = new DOMParser().parseFromString(text, 'text/html');
      const products = [...page.querySelectorAll('[data-saiko-complement-results] [data-saiko-candidate]')].flatMap(node => {
        try { return [JSON.parse(node.dataset.saikoCandidate)]; } catch { return []; }
      });
      if (cache.size > 30) cache.delete(cache.keys().next().value);
      cache.set(key, { time: Date.now(), products });
      return products;
    }

    async nativeRecommendations(source, intent, signal) {
      const state = SaikoCartComplement.state;
      const key = `${this.config.locale}|${this.config.currency}|native:${source.id}:${intent}`;
      const saved = state.cache.get(key);
      if (saved && Date.now() - saved.time < 60000) return saved.products;
      const url = new URL(this.endpoint('recommendations/products.json'), location.origin);
      url.search = new URLSearchParams({ product_id: source.id, limit: 10, intent });
      const response = await this.request(url, { signal, timeout: 2500 });
      const products = (response.products || []).flatMap(product => {
        const variant = product.variants?.find(purchasable);
        if (!variant || product.requires_selling_plan) return [];
        const image = variant.featured_image?.src || (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src) || product.images?.[0];
        if (!image || typeof image !== 'string') return [];
        state.products.set(`${this.config.locale}|${this.config.currency}|${product.id}`, { time: Date.now(), product });
        return [{ id: product.id, title: product.title, handle: product.handle, type: product.type, tags: Array.isArray(product.tags) ? product.tags : [], url: product.url || this.endpoint(`products/${encodeURIComponent(product.handle)}`), available: product.available, giftCard: product.gift_card, image, variantId: variant.id, variantTitle: variant.title, variantsCount: product.variants.length, price: Number(variant.price), money: this.money(Number(variant.price)), compareAtPrice: Number(variant.compare_at_price) || 0, compareAtMoney: variant.compare_at_price ? this.money(Number(variant.compare_at_price)) : '', minimum: variant.quantity_rule?.min || 1, increment: variant.quantity_rule?.increment || 1, maximum: variant.quantity_rule?.max, manualComplement: intent === 'complementary', shopifyRelated: intent === 'related' }];
      });
      state.cache.set(key, { time: Date.now(), products });
      return products;
    }

    async resolveCandidate(candidate, signal) {
      if (candidate.variantsCount <= 1 || !candidate.variantsCount) return { ...candidate, resolved: true };
      const state = SaikoCartComplement.state;
      const key = `${this.config.locale}|${this.config.currency}|${candidate.id}`;
      try {
        let saved = state.products.get(key);
        if (!saved || Date.now() - saved.time > 30000) {
          saved = { time: Date.now(), product: await this.request(this.endpoint(`products/${encodeURIComponent(candidate.handle)}.js`), { signal, timeout: 4000 }) };
          state.products.set(key, saved);
        }
        if (saved.product.requires_selling_plan) return null;
        const variants = saved.product.variants.filter(purchasable);
        const names = context(candidate).characters;
        const words = variant => tokenize(variant.title).map(word => word === 'zorro' ? 'zoro' : word === 'sanjii' ? 'sanji' : word);
        const selected = variants.find(variant => Number(variant.id) === state.choices.get(Number(candidate.id)));
        const matching = variants.find(variant => names.some(name => words(variant).includes(name)));
        const hasNamedVariants = variants.some(variant => words(variant).length);
        const original = variants.find(variant => Number(variant.id) === Number(candidate.variantId));
        const variant = selected || matching || (!names.length || !hasNamedVariants ? original || variants[0] : null);
        if (!variant) return null;
        return { ...candidate, resolved: true, variantId: variant.id, variantTitle: variant.title, price: Number(variant.price), money: this.money(Number(variant.price)), compareAtPrice: Number(variant.compare_at_price) || 0, compareAtMoney: variant.compare_at_price ? this.money(Number(variant.compare_at_price)) : '', image: variant.featured_image?.src || candidate.image };
      } catch { return null; }
    }

    async load() {
      if (!this.isConnected || !this.config) return;
      this.readController?.abort();
      this.readController = new AbortController();
      const controller = this.readController;
      this.card.hidden = true;
      this.items.clear();
      this.grid.replaceChildren();
      this.showNotice();
      const source = this.source();
      if (!source) return;
      const info = context(source, true);
      if (!info.universes.length) return;
      const anime = `"${normalize(info.query)}"`;
      const groups = [
        ['figurine', 'figure', 'statue', 'statuette'],
        ['lampe', 'lamp', 'light', 'poster', 'banniere', 'banner', 'decoration', 'deko'],
        ['shirt', 'sweat', 'hoodie', 'pull', 'veste', 'jacket', 'vetement'],
        ['mug', 'tasse', 'porte-cles', 'keychain', 'schlusselanhanger', 'sticker', 'pin', 'goodies', 'peluche', 'plush', 'sac', 'bag', 'coussin', 'cushion', 'kissen']
      ];
      const queries = groups.map(words => `${anime} AND (${words.map(word => `title:${word}`).join(' OR ')})`);
      if (info.characters.length) queries.unshift(`${anime} AND (${info.characters.slice(0, 5).map(word => `"${word}"`).join(' OR ')})`);
      const results = await Promise.allSettled([
        ...queries.map(query => this.candidates(query, controller.signal)),
        this.nativeRecommendations(source, 'related', controller.signal),
        this.nativeRecommendations(source, 'complementary', controller.signal)
      ]);
      if (controller.signal.aborted || !this.isConnected || controller !== this.readController) return;
      let products = results.flatMap(result => result.status === 'fulfilled' ? result.value : []);
      const ids = new Set([...this.config.items.map(item => Number(item.id)), ...SaikoCartComplement.state.blocked]);
      let selected = SaikoCartComplement.select(products, source, ids, this.config.items);
      if (selected.length < 4) {
        try { products = [...products, ...await this.candidates(anime, controller.signal)]; } catch {}
        if (controller.signal.aborted || !this.isConnected || controller !== this.readController) return;
        selected = SaikoCartComplement.select(products, source, ids, this.config.items);
      }
      for (let round = 0; round < 2; round++) {
        const pending = selected.filter(product => !product.resolved);
        if (!pending.length) break;
        const resolved = await Promise.all(pending.map(product => this.resolveCandidate(product, controller.signal)));
        if (controller.signal.aborted || !this.isConnected || controller !== this.readController) return;
        const visited = new Set(pending.map(product => Number(product.id)));
        products = products.filter(product => !visited.has(Number(product.id)));
        products.push(...resolved.filter(Boolean));
        resolved.forEach((product, index) => { if (!product) ids.add(Number(pending[index].id)); });
        selected = SaikoCartComplement.select(products, source, ids, this.config.items);
      }
      const ready = products.filter(product => product.resolved);
      selected = SaikoCartComplement.select(ready, source, ids, this.config.items);
      for (const product of selected) this.renderCandidate(product);
      this.card.hidden = !this.items.size;
      this.hidden = this.card.hidden && this.status.hidden;
      this.setBusy();
      this.updateNavigation();
      if (this.items.size) requestAnimationFrame(() => this.updateNavigation());
    }

    renderCandidate(product) {
      if (SaikoCartComplement.state.blocked.has(Number(product.id))) return;
      let url, image;
      try { url = new URL(product.url, location.origin); image = new URL(product.image, location.origin); } catch { return; }
      if (url.origin !== location.origin || !url.pathname.includes('/products/') || !['https:', 'http:'].includes(image.protocol)) return;
      const tile = this.template.content.firstElementChild.cloneNode(true);
      tile.dataset.productId = product.id;
      const title = String(product.title).split(/[|｜]/)[0].replace(/\s+/g, ' ').trim();
      tile.querySelector('[data-name]').textContent = title;
      tile.querySelector('[data-name]').title = product.title;
      tile.querySelector('[data-image]').src = image.href;
      tile.querySelector('[data-variants]').setAttribute('aria-label', `${this.config.messages.choose} — ${title}`);
      this.items.set(Number(product.id), { product, tile, variants: [], baseImage: product.image });
      this.grid.append(tile);
      this.updateVariantUI(product.id);
      if (product.variantsCount > 1) {
        tile.dataset.loading = 'true';
        this.hydrateVariants(product.id);
      }
    }

    money(price) {
      if (window.theme?.Currency?.formatMoney && this.config.moneyFormat) {
        const value = document.createElement('span');
        value.innerHTML = window.theme.Currency.formatMoney(price, this.config.moneyFormat);
        return value.textContent;
      }
      return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(price / 100);
    }

    async hydrateVariants(id) {
      const entry = this.items.get(Number(id));
      if (!entry) return;
      const state = SaikoCartComplement.state;
      const key = `${this.config.locale}|${this.config.currency}|${id}`;
      try {
        let saved = state.products.get(key);
        if (!saved || Date.now() - saved.time > 30000) {
          const product = await this.request(this.endpoint(`products/${encodeURIComponent(entry.product.handle)}.js`), { signal: this.readController.signal });
          saved = { time: Date.now(), product };
          state.products.set(key, saved);
        }
        if (!this.isConnected || this.items.get(Number(id)) !== entry) return;
        entry.variants = saved.product.requires_selling_plan ? [] : saved.product.variants.filter(purchasable);
        const names = context(entry.product).characters;
        const matching = entry.variants.filter(variant => tokenize(variant.title).map(word => word === 'zorro' ? 'zoro' : word === 'sanjii' ? 'sanji' : word).some(word => names.includes(word)));
        if (matching.length) entry.variants = matching;
        if (!entry.variants.length) { this.removeCandidate(id); return; }
        const select = entry.tile.querySelector('[data-variants]');
        entry.variants.forEach(variant => {
          const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; select.append(option);
        });
        select.hidden = entry.variants.length < 2;
        const chosen = entry.variants.find(variant => Number(variant.id) === state.choices.get(Number(id))) || entry.variants.find(variant => Number(variant.id) === Number(entry.product.variantId));
        if (!chosen) { this.removeCandidate(id); return; }
        this.selectVariant(id, Number(chosen.id));
      } catch { if (this.isConnected && this.items.get(Number(id)) === entry) this.removeCandidate(id); }
      finally { delete entry.tile.dataset.loading; if (this.isConnected) this.setBusy(); }
    }

    selectVariant(id, variantId) {
      const entry = this.items.get(Number(id));
      const variant = entry?.variants.find(item => Number(item.id) === Number(variantId));
      if (!variant) return;
      SaikoCartComplement.state.choices.set(Number(id), Number(variant.id));
      Object.assign(entry.product, { variantId: variant.id, variantTitle: variant.title, price: Number(variant.price), money: this.money(Number(variant.price)), compareAtPrice: Number(variant.compare_at_price) || 0, compareAtMoney: variant.compare_at_price ? this.money(Number(variant.compare_at_price)) : '' });
      entry.product.image = variant.featured_image?.src || entry.baseImage;
      entry.tile.querySelector('[data-variants]').value = String(variant.id);
      this.updateVariantUI(id);
    }

    updateVariantUI(id) {
      const entry = this.items.get(Number(id));
      if (!entry) return;
      const { product, tile } = entry;
      const url = new URL(product.url, location.origin);
      url.searchParams.set('variant', product.variantId);
      tile.querySelectorAll('[data-link]').forEach(link => { link.href = url.pathname + url.search; });
      tile.querySelector('[data-price]').textContent = product.money;
      const onSale = Number(product.compareAtPrice) > Number(product.price);
      tile.querySelector('[data-compare-wrap]').hidden = !onSale;
      tile.querySelector('[data-compare-price]').textContent = onSale ? product.compareAtMoney || this.money(Number(product.compareAtPrice)) : '';
      tile.querySelector('[data-regular-label]').hidden = onSale;
      tile.querySelector('[data-sale-label]').hidden = !onSale;
      tile.querySelector('[data-image]').src = product.image;
      const option = tile.querySelector('[data-variant]');
      option.textContent = product.variantTitle === 'Default Title' ? '' : product.variantTitle || '';
      option.hidden = !option.textContent || !tile.querySelector('[data-variants]').hidden;
      tile.querySelector('[data-add]').setAttribute('aria-label', `${this.config.messages.add} — ${product.title}${option.textContent ? ` — ${option.textContent}` : ''}`);
    }

    removeCandidate(id) {
      const entry = this.items.get(Number(id));
      entry?.tile.remove();
      this.items.delete(Number(id));
      this.card.hidden = !this.items.size;
      this.hidden = this.card.hidden && this.status.hidden;
      this.updateNavigation();
    }

    updateNavigation() {
      if (!this.previous || !this.next) return;
      const scroll = Math.abs(this.grid.scrollLeft);
      const maximum = this.grid.scrollWidth - this.grid.clientWidth;
      this.querySelector('[data-navigation]').hidden = this.items.size <= 2;
      this.previous.disabled = scroll <= 2;
      this.next.disabled = maximum > 0 ? scroll >= maximum - 2 : this.items.size <= 2;
      this.fitHeader();
    }

    move(direction) {
      const step = (this.grid.clientWidth || 1) + 8;
      const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.grid.scrollBy({ left: direction * step * rtl, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    setBusy() {
      const state = SaikoCartComplement.state;
      for (const [id, entry] of this.items) {
        const button = entry.tile.querySelector('[data-add]');
        const active = state.busy && state.addingId === id;
        button.disabled = state.busy || Boolean(state.pending) || entry.tile.dataset.loading === 'true';
        button.setAttribute('aria-busy', String(active || entry.tile.dataset.loading === 'true'));
        button.textContent = active ? this.config.messages.adding : this.config.messages.add;
        entry.tile.querySelector('[data-variants]').disabled = state.busy || Boolean(state.pending);
      }
    }

    async add(id) {
      const state = SaikoCartComplement.state;
      const entry = this.items.get(Number(id));
      const source = this.source();
      if (state.busy || state.pending || !entry || !source || entry.tile.querySelector('[data-add]').disabled) return;
      const candidate = { ...entry.product };
      state.sourceId = Number(source.id);
      state.busy = true;
      state.addingId = Number(id);
      const focused = this.contains(document.activeElement);
      SaikoCartComplement.instances.forEach(instance => instance.setBusy());
      let mutationStarted = false;
      let mutationSucceeded = false;
      try {
        const [cart, product] = await Promise.all([
          this.request(this.endpoint('cart.js')),
          this.request(this.endpoint(`products/${encodeURIComponent(candidate.handle)}.js`))
        ]);
        if (cart.items.some(item => Number(item.product_id) === Number(candidate.id))) {
          state.blocked.add(Number(candidate.id));
          this.removeCandidate(id);
          await this.renderCart(cart);
          this.notice('exists', { focus: focused });
          return;
        }
        if (!cart.items.some(item => Number(item.product_id) === Number(source.id))) {
          await this.renderCart(cart);
          return;
        }
        const variant = product.variants?.find(item => Number(item.id) === Number(candidate.variantId));
        if (!purchasable(variant) || product.requires_selling_plan) {
          state.blocked.add(Number(candidate.id));
          this.removeCandidate(id);
          this.message(this.config.messages.unavailable, true);
          return;
        }
        entry.product.compareAtPrice = Number(variant.compare_at_price) || 0;
        entry.product.compareAtMoney = variant.compare_at_price ? this.money(Number(variant.compare_at_price)) : '';
        if (Number(variant.price) !== candidate.price) {
          entry.product.price = Number(variant.price);
          entry.product.money = this.money(entry.product.price);
          this.updateVariantUI(id);
          this.message(this.config.messages.priceChanged);
          return;
        }
        mutationStarted = true;
        const added = await this.request(this.endpoint('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: candidate.variantId, quantity: 1, properties: { _saiko_upsell: 'Panier' } }], sections: this.bundledSections(), sections_url: location.pathname })
        });
        mutationSucceeded = true;
        state.blocked.add(Number(candidate.id));
        this.removeCandidate(id);
        const updated = await this.request(this.endpoint('cart.js'));
        await this.renderCart(updated, added.sections);
        this.notice('added', { focus: focused });
      } catch (error) {
        if (mutationSucceeded || (mutationStarted && (!error.status || error.status >= 500 || error.status === 408))) {
          state.blocked.add(Number(candidate.id));
          state.pending = { id: candidate.id, sourceId: source.id, focused, knownSuccess: mutationSucceeded };
          this.removeCandidate(id);
          this.notice(mutationSucceeded ? 'refreshNeeded' : 'uncertain', { error: !mutationSucceeded, refresh: true });
          await this.recover();
        } else if (this.isConnected) {
          if (error.status === 422 || error.status === 404) {
            state.blocked.add(Number(candidate.id));
            this.removeCandidate(id);
          }
          this.message(this.config.messages[error.status === 422 || error.status === 404 ? 'unavailable' : 'error'], true);
        }
      } finally {
        state.busy = false;
        state.addingId = null;
        SaikoCartComplement.instances.forEach(instance => instance.setBusy());
      }
    }

    async recover() {
      const state = SaikoCartComplement.state;
      if (state.recovering) return;
      state.recovering = true;
      this.refreshButton.disabled = true;
      try {
        const cart = await this.request(this.endpoint('cart.js'));
        const pending = state.pending;
        const confirmed = pending && cart.items.some(item => Number(item.product_id) === Number(pending.id));
        await this.renderCart(cart);
        if (confirmed) {
          state.pending = null;
          this.notice('added', { focus: pending.focused });
        } else this.notice('uncertain', { error: true, refresh: true });
      } catch {
        this.notice(state.pending?.knownSuccess ? 'refreshNeeded' : 'uncertain', { error: !state.pending?.knownSuccess, refresh: true });
      } finally {
        state.recovering = false;
        SaikoCartComplement.instances.forEach(instance => { instance.refreshButton.disabled = false; instance.setBusy(); });
      }
    }

    message(text, error = false, refresh = false) {
      this.status.textContent = text || '';
      this.status.hidden = !text;
      this.status.toggleAttribute('data-error', error);
      this.refreshButton.hidden = !refresh;
      this.hidden = this.card.hidden && !text;
    }

    showNotice() {
      clearTimeout(this.noticeTimer);
      const notice = SaikoCartComplement.state.notice;
      if (!notice || notice.until < Date.now()) { this.message(''); return; }
      this.message(this.config.messages[notice.key], notice.error, notice.refresh);
      if (notice.focus) { notice.focus = false; this.status.focus({ preventScroll: true }); }
      if (!notice.refresh) this.noticeTimer = setTimeout(() => { if (this.isConnected) this.message(''); }, Math.max(0, notice.until - Date.now()));
    }

    notice(key, options = {}) {
      SaikoCartComplement.state.notice = { key, until: options.refresh ? Infinity : Date.now() + 4500, ...options };
      SaikoCartComplement.instances.forEach(instance => instance.showNotice());
    }

    bundledSections() {
      const sections = [this.config.sectionId];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
      return [...new Set(sections.filter(Boolean))].slice(0, 5);
    }

    async renderCart(cart, sections = {}) {
      sections = sections || {};
      const id = this.config.sectionId;
      const valid = html => typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').getElementById(`MiniCart-${id}`);
      if (!valid(sections[id])) {
        const url = new URL(location.pathname, location.origin);
        url.searchParams.set('sections', id);
        const fresh = await this.request(url);
        sections = { ...sections, ...fresh };
      }
      if (!valid(sections[id])) throw new Error('Cart section unavailable');
      const bus = window.theme?.pubsub;
      if (!bus) throw new Error('Cart integration unavailable');
      const scroll = document.getElementById(`MiniCart-${id}`)?.querySelector('.drawer__scrollable');
      const scrollTop = scroll?.scrollTop || 0;
      cart.sections = sections;
      bus.publish(bus.PUB_SUB_EVENTS.cartUpdate, { source: 'saiko-cart-complement', cart });
      requestAnimationFrame(() => {
        const next = document.getElementById(`MiniCart-${id}`)?.querySelector('.drawer__scrollable');
        if (next) next.scrollTop = scrollTop;
      });
    }

  }

  customElements.define('saiko-cart-complement', SaikoCartComplement);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saiko-cartes-produits"] && !Shopify.designMode) return;
  try {
    (() => {
    const translationsElement = document.querySelector('[data-saiko-product-card-translations]');
    let translations = { inStock: '' };

    if (translationsElement) {
      try {
        translations = { ...translations, ...JSON.parse(translationsElement.textContent) };
      } catch (error) {
        // Keep the empty fallback rather than injecting a hard-coded customer-facing label.
      }
    }

    const searchAvailabilityCache = new Map();

    const normalizeStockBadge = (stock) => {
      if (stock.classList.contains('saiko-card-stock-badge')) return;

      const icon = document.createElement('span');
      icon.className = 'saiko-card-stock-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 6.2 4.55 8.7 10 3.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const label = document.createElement('span');
      label.className = 'saiko-card-stock-label';
      label.textContent = translations.inStock;

      stock.replaceChildren(icon, label);
      stock.classList.add('saiko-card-stock-badge');
      stock.setAttribute('aria-label', translations.inStock);
    };

    const arrangeProductCards = (root = document) => {
      const cards = [];

      if (root.matches && root.matches('.product-card')) {
        cards.push(root);
      }

      if (root.querySelectorAll) {
        cards.push(...root.querySelectorAll('.product-card'));
      }

      cards.forEach((card) => {
        const price = card.querySelector('.price');
        const stock = card.querySelector('.product-instock');

        if (!price || !stock) return;

        normalizeStockBadge(stock);

        let row = card.querySelector('.saiko-card-price-stock');

        if (!row) {
          row = document.createElement('div');
          row.className = 'saiko-card-price-stock';
          price.parentNode.insertBefore(row, price);
        }

        if (price.parentNode !== row) row.prepend(price);
        if (stock.parentNode !== row) row.append(stock);
      });
    };

    const getSearchProductAvailability = (link) => {
      const productUrl = new URL(link.href, window.location.origin);
      const productPath = productUrl.pathname.replace(/\/$/, '');

      if (!searchAvailabilityCache.has(productPath)) {
        const availabilityRequest = fetch(`${productPath}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) throw new Error('Product availability unavailable');
            return response.json();
          })
          .then((product) => product.available === true)
          .catch(() => null);

        searchAvailabilityCache.set(productPath, availabilityRequest);
      }

      return searchAvailabilityCache.get(productPath);
    };

    const addSearchStockBadge = (item, row) => {
      const existingStock = item.querySelector('.product-instock');

      if (existingStock) {
        normalizeStockBadge(existingStock);
        if (existingStock.parentNode !== row) row.append(existingStock);
        return;
      }

      if (item.dataset.saikoStockStatus === 'loading' || item.dataset.saikoStockStatus === 'ready') return;

      const link = item.querySelector('.horizontal-product__title[href*="/products/"]');
      if (!link) return;

      item.dataset.saikoStockStatus = 'loading';

      getSearchProductAvailability(link).then((available) => {
        if (!item.isConnected) return;

        item.dataset.saikoStockStatus = 'ready';
        if (available !== true || item.querySelector('.product-instock')) return;

        const stock = document.createElement('span');
        stock.className = 'product-instock saiko-search-stock-badge';
        normalizeStockBadge(stock);
        row.append(stock);
      });
    };

    const arrangeSearchResults = (root = document) => {
      const items = [];
      const selector = '#SearchDrawer .horizontal-products .horizontal-product, form[is="predictive-search"] .horizontal-products .horizontal-product';

      if (root.matches && root.matches(selector)) items.push(root);
      if (root.querySelectorAll) items.push(...root.querySelectorAll(selector));

      items.forEach((item) => {
        const price = item.querySelector('.horizontal-product__details .price');
        if (!price) return;

        let row = item.querySelector('.saiko-search-price-stock');

        if (!row) {
          row = document.createElement('div');
          row.className = 'saiko-search-price-stock';
          price.parentNode.insertBefore(row, price);
        }

        if (price.parentNode !== row) row.prepend(price);
        addSearchStockBadge(item, row);
      });
    };

    const startSaikoProductCards = () => {
      arrangeProductCards();
      arrangeSearchResults();

      if (window.saikoProductCardObserver) return;

      window.saikoProductCardObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            arrangeProductCards(node);
            arrangeSearchResults(node);
          });
        });
      });

      window.saikoProductCardObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startSaikoProductCards, { once: true });
    } else {
      startSaikoProductCards();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saiko-champs-meta-produit"] && !Shopify.designMode) return;
  try {
    const saikoStyleProductNotices = (scope = document) => {
    const blocks = [];
    if (scope.matches?.('.product__text')) blocks.push(scope);
    scope.querySelectorAll?.('.product__text').forEach((block) => blocks.push(block));

    blocks.forEach((block) => {
      if (block.classList.contains('saiko-product-notice')) return;
      if (!block.closest('product-info, .product__gallery-container')) return;

      const inner = block.querySelector(':scope > .product__text-inner');
      const text = inner?.querySelector(':scope > .rte');
      if (!text || !/^\s*\u26a0/u.test(text.textContent || '')) return;

      const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
      let firstText = walker.nextNode();
      while (firstText && !firstText.textContent.trim()) firstText = walker.nextNode();
      if (!firstText) return;

      firstText.textContent = firstText.textContent.replace(/^\s*\u26a0[\ufe0e\ufe0f]?\s*/u, '');

      const icon = document.createElement('span');
      icon.className = 'saiko-product-notice__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M12 7v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="16.5" r="1" fill="currentColor"/></svg>';
      inner.prepend(icon);
      block.classList.add('saiko-product-notice');
    });
  };

  const saikoCreateMetaFeaturePanel = (feature) => {
    if (!feature?.matches('.product__text')) return null;

    const featureText = feature.textContent?.replace(/\s+/g, ' ').trim() || '';
    const featureLabel = featureText.match(/\bLEDs?\b/i);
    if (!featureLabel) return null;

    const panel = document.createElement('details');
    const summary = document.createElement('summary');
    const label = document.createElement('div');
    const labelText = document.createElement('span');
    const content = document.createElement('div');
    const featureIcon = feature.querySelector('figure')?.cloneNode(true);

    panel.className = 'product__accordion details with-border saiko-meta-tabs__panel--feature';
    summary.className = 'details__summary flex items-center justify-between gap-2 cursor-pointer';
    label.className = 'flex items-center gap-2d5';
    labelText.className = 'text-sm-base font-bold leading-none';
    labelText.textContent = featureLabel[0].replace(/s$/i, '');
    content.className = 'details__content rte text-opacity';

    if (featureIcon) {
      featureIcon.className = 'saiko-meta-tabs__feature-icon';
      label.append(featureIcon);
    }

    label.append(labelText);
    summary.append(label);
    content.append(feature);
    panel.append(summary, content);

    return panel;
  };

  const saikoActivateMetaTab = (wrapper, index, moveFocus = false) => {
    const tabs = Array.from(wrapper.querySelectorAll('.saiko-meta-tabs__tab'));
    const panels = Array.from(wrapper.querySelectorAll('.saiko-meta-tabs__panel'));

    tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      panels[tabIndex].open = selected;
    });

    if (moveFocus) {
      tabs[index].focus();
      tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  };

  const saikoBuildMetaTabs = (scope = document) => {
    saikoStyleProductNotices(scope);
    const metaScopes = [];

    if (scope.matches?.('product-info, .product__gallery-container')) metaScopes.push(scope);
    scope.querySelectorAll?.('product-info, .product__gallery-container').forEach((metaScope) => metaScopes.push(metaScope));

    metaScopes.forEach((metaScope, metaScopeIndex) => {
      const children = Array.from(metaScope.children);
      const groups = [];
      let currentGroup = [];

      children.forEach((child) => {
        const isMetaAccordion = child.matches('.product__accordion.details.with-border:not(.saiko-meta-tabs__panel)');

        if (isMetaAccordion) {
          currentGroup.push(child);
          return;
        }

        if (currentGroup.length > 1 || currentGroup[0]?.classList.contains('saiko-meta-tabs__source-panel')) groups.push(currentGroup);
        currentGroup = [];
      });

      if (currentGroup.length > 1 || currentGroup[0]?.classList.contains('saiko-meta-tabs__source-panel')) groups.push(currentGroup);

      groups.forEach((group, groupIndex) => {
        if (group.some((panel) => panel.closest('.saiko-meta-tabs'))) return;

        const hasProductIconPanels = group.some((panel) => panel.classList.contains('saiko-meta-tabs__source-panel'));
        const feature = hasProductIconPanels ? null : group[group.length - 1].nextElementSibling;
        const featurePanel = saikoCreateMetaFeaturePanel(feature);
        const panels = featurePanel ? [...group, featurePanel] : group;
        const wrapper = document.createElement('div');
        const headingTemplate = document.querySelector('template[data-saiko-meta-heading]');
        const heading = headingTemplate?.content.firstElementChild?.cloneNode(true);
        const configuredHeading = group.map((panel) => panel.dataset.saikoMetaHeading).find(Boolean);
        const nav = document.createElement('div');
        const panelsContainer = document.createElement('div');
        const baseId = `${metaScope.id || `product-meta-${metaScopeIndex}`}-meta-${groupIndex}`;

        wrapper.className = 'saiko-meta-tabs';
        wrapper.style.setProperty('--saiko-tab-count', panels.length);
        wrapper.dataset.saikoTabsReady = 'true';
        nav.className = 'saiko-meta-tabs__nav';
        nav.setAttribute('role', 'tablist');
        panelsContainer.className = 'saiko-meta-tabs__panels';

        const hasCustomHeading = configuredHeading?.trim()
          && configuredHeading.trim().normalize('NFC').toLowerCase() !== 'caractéristiques';
        if (heading && hasCustomHeading) heading.querySelector('span').textContent = configuredHeading;

        metaScope.insertBefore(wrapper, group[0]);
        if (heading) wrapper.append(heading);
        wrapper.append(nav, panelsContainer);

        let initialIndex = panels.findIndex((panel) => panel.open);
        if (initialIndex < 0) initialIndex = 0;

        panels.forEach((panel, index) => {
          const summary = panel.querySelector(':scope > .details__summary');
          const label = summary?.querySelector(':scope > div');
          const tab = document.createElement('button');
          const tabId = `${baseId}-tab-${index}`;
          const panelId = `${baseId}-panel-${index}`;

          tab.type = 'button';
          tab.className = 'saiko-meta-tabs__tab';
          tab.id = tabId;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panelId);
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          tab.append(label ? label.cloneNode(true) : document.createTextNode(summary?.textContent.trim() || ''));

          panel.classList.add('saiko-meta-tabs__panel');
          panel.id = panelId;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          panelsContainer.append(panel);
          nav.append(tab);

          tab.addEventListener('click', () => saikoActivateMetaTab(wrapper, index));
          tab.addEventListener('keydown', (event) => {
            let targetIndex = index;

            if (event.key === 'ArrowRight') targetIndex = (index + 1) % panels.length;
            if (event.key === 'ArrowLeft') targetIndex = (index - 1 + panels.length) % panels.length;
            if (event.key === 'Home') targetIndex = 0;
            if (event.key === 'End') targetIndex = panels.length - 1;
            if (targetIndex === index) return;

            event.preventDefault();
            saikoActivateMetaTab(wrapper, targetIndex, true);
          });
        });

        saikoActivateMetaTab(wrapper, initialIndex);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => saikoBuildMetaTabs(document), { once: true });
  } else {
    saikoBuildMetaTabs(document);
  }

  document.addEventListener('shopify:section:load', (event) => saikoBuildMetaTabs(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest?.('.saiko-meta-tabs__panel');
    const wrapper = panel?.closest('.saiko-meta-tabs');
    if (!panel || !wrapper) return;

    const panels = Array.from(wrapper.querySelectorAll('.saiko-meta-tabs__panel'));
    saikoActivateMetaTab(wrapper, panels.indexOf(panel));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saiko-product-duo"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('saiko-product-duo')) return;
  const eligible = variant => {
    const rule = variant?.quantity_rule || {};
    return Boolean(variant?.available) && !variant.requires_selling_plan && Number(variant.price) > 0 && Number(rule.min || 1) <= 1 && Number(rule.increment || 1) === 1 && (rule.max == null || Number(rule.max) >= 1);
  };
  const quantity = (cart, id) => cart.items.reduce((sum, item) => sum + (Number(item.variant_id) === Number(id) ? Number(item.quantity) : 0), 0);
  const DuoEngine = (() => {
  const norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const ignored = new Set(('figurine figure figur figuren sammelfigur figures figurines statue statuette poster posters affiche bannieres banniere banner banners wall hanging lampe lamp light led veilleuse porte cles cle clefs keychain keyring schlusselanhanger shirt tshirt tee t sweat hoodie pull veste jacket tasse mug sticker stickers pin pins badge magnet aimant marque page bookmark decoration decorations deko goodies accessoire accessoires anime manga collection set lot pack limited edition version style design kawaii chibi wanted bounty premium officiel official oversize coton cotton taille size model modele color couleur black white noir blanc noirblanc rouge red bleu blue green vert mini grand petit avec sans pour les des une un the and with for der die das mit von und roronoa monkey uchiha uzumaki kamado ackerman jaeger yeager son gear wano dressrosa combat warrior guerre guerrier fire kick tornado monster point boxpack pvc resin resine acrylic pink rose purple violet yellow jaune orange brown marron silver argent gold dore beige framed unframed cadre cadres frame mount mounted coussin cushion kissen housse pillow peluche plush pluesch plueschtier sac bag tasche posterwand articulable articule articulee articulated action collector collectible statuettes figur neon acrylique bois wooden wood canvas toile painting small medium large extra regular slim short long manches sleeve sleeves sleeveless homme femme enfant men women kids boy girl box boite boites boitecarton sansboite without original soft polyester blackwhite default title gris grey gray dark usb plug prise europe eu uk us standard standardtitel defaulttitle farbe grosse groesse modell colorful multicolor multicolore super saiyan saiyajin ultra instinct god blue forme transformation cheveux hair anime action personnage characters personnage personnages casquette cap bonnet beanie chapeau hat necklace collier bracelet bijoux pants pantalon jogger jogging hooded zipper zip zipee button baseball football sport sports printed imprime jersey mantel kleidung kleid schuhe schirmmutze hose jacke oberteil halskette armband schmuck ringe schlusselanhanger rucksack schwarz weiss rot blau grun rosa grau xxl xxxl xxxxl xxxxxl xxs xxxs regular fit loose oversized embroidered embroidery embroidery best sale uni universal unique einheitsgrosse groesse mitohne nendoroid funko posket pop').split(' '));
  const aliases = new Map([
    ['onepiece', 'one piece'], ['dbz', 'dragon ball'], ['dragonball', 'dragon ball'], ['dragonball z', 'dragon ball'], ['dragon ball z', 'dragon ball'], ['dragon ball super', 'dragon ball'], ['dragon ball gt', 'dragon ball'],
    ['l attaque des titans', 'attack on titan'], ['attaque des titans', 'attack on titan'], ['shingeki no kyojin', 'attack on titan'],
    ['kimetsu no yaiba', 'demon slayer'], ['boku no hero academia', 'my hero academia'], ['naruto shippuden', 'naruto'], ['jujutsu kaisen jjk', 'jujutsu kaisen'], ['pokemon', 'pokemon']
  ]);
  const knownSeries = ['one piece','dragon ball','naruto','boruto','demon slayer','attack on titan','my hero academia','jujutsu kaisen','hunter x hunter','bleach','death note','chainsaw man','berserk','fairy tail','sailor moon','tokyo ghoul','tokyo revengers','fullmetal alchemist','spy x family','evangelion','sword art online','one punch man','haikyuu','blue lock','black clover','saint seiya','jojo','pokemon','gintama','dr stone','solo leveling','dandadan','frieren','marvel','dc comics'];
  const canonical = value => aliases.get(norm(value)) || norm(value);
  const words = value => {
    const normalized = norm(value);
    return normalized.split(' ').filter(word => word.length >= 3 && !ignored.has(word) && !/\d/.test(word)).map(word => ({zorro:'zoro',sanjii:'sanji',kakarot:'goku',kakarotto:'goku',levi:'levi',livaï:'levi'})[word] || word);
  };
  const tags = product => Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').filter(Boolean);
  const values = (product, prefixes) => tags(product).flatMap(tag => {
    const split = String(tag).indexOf(':');
    return split > 0 && prefixes.includes(norm(tag.slice(0, split))) ? [tag.slice(split + 1).trim()] : [];
  });
  const context = (product, preferVariant = false) => {
    const parts = String(product.title || product.product_title || '').split(/[|｜]/);
    let universes = values(product, ['anime','licence','license','franchise']);
    if (!universes.length && parts.length > 1) universes = [parts.at(-1).trim()];
    if (!universes.length) {
      const text = ` ${norm(`${product.title} ${product.handle} ${product.type} ${tags(product).join(' ')}`)} `;
      universes = [...knownSeries, ...aliases.keys()].filter(name => text.includes(` ${name} `));
    }
    universes = [...new Set(universes.map(canonical))].filter(value => value && !['anime','manga','pop culture','manga anime'].includes(value));
    const universeWords = new Set(universes.join(' ').split(' '));
    const explicit = values(product,['personnage','character']);
    const variant = product.variantTitle || product.variant_title || '';
    const variantWords = product.hasOnlyDefaultVariant === false ? words(variant) : [];
    const characterText = preferVariant && variantWords.length ? variant : explicit.length ? explicit.join(' ') : parts[0];
    const characters = [...new Set(words(characterText).filter(word => (!universeWords.has(word) || ['naruto','boruto'].includes(word))))];
    const query = parts.length > 1 ? parts.at(-1).trim() : values(product,['anime','licence','license','franchise'])[0] || universes[0] || '';
    return {universes,characters,query};
  };
  const patterns = [
    ['keychain',/\b(porte cle[fs]*|porte cles|keychain|keyring|schlusselanhanger)\b/],
    ['poster',/\b(poster[s]?|affiche[s]?|kunstdruck|banniere[s]?|banner[s]?|wall hanging)\b/],
    ['sticker',/\b(sticker[s]?|autocollant[s]?)\b/],['pin',/\b(pin[s]?|badge|broche)\b/],['magnet',/\b(magnet|aimant)\b/],['bookmark',/\b(marque page|bookmark|lesezeichen)\b/],
    ['mug',/\b(mug|tasse)\b/],['lamp',/\b(lampe|lamp|veilleuse|neon)\b/],['cushion',/\b(coussin|cushion|kissen|pillow|housse)\b/],['plush',/\b(peluche|plush|pluesch|plueschtier)\b/],
    ['bag',/\b(sac|bag|tasche|rucksack)\b/],['headwear',/\b(casquette|cap|bonnet|beanie|chapeau|mutze)\b/],['jewelry',/\b(bracelet|collier|necklace|bijou[x]?|ring|bague|halskette|armband|schmuck)\b/],
    ['top',/\b(t shirt|tshirt|shirt|maillot|jersey|debardeur|chemise|hemd)\b/],['layer',/\b(sweat|hoodie|pull|veste|jacket|jacke|mantel)\b/],['bottom',/\b(short|pantalon|pants|jogging|jogger|hose)\b/],['footwear',/\b(chaussure[s]?|shoes|schuhe|chaussette[s]?|socks)\b/],
    ['figure',/\b(figurine[s]?|figure[s]?|figur|figuren|sammelfigur|statue|statuette)\b/],['clothing',/\b(vetement[s]?|clothing|kleidung)\b/],['decoration',/\b(decoration|decorations|deko)\b/],['goodie',/\bgoodies\b/]
  ];
  const kind = product => {
    for(const text of [`${product.title || product.product_title} ${product.handle}`,product.type || product.product_type]) {
      const normalized=norm(text);
      const found=patterns.find(([,pattern])=>pattern.test(normalized));
      if(found)return found[0];
    }
    return '';
  };
  const family = category => ['top','layer','bottom','footwear','headwear','clothing'].includes(category) ? 'clothing' : ['lamp','poster','cushion','decoration'].includes(category) ? 'decoration' : category === 'figure' ? 'figure' : 'goodie';
  const same = (a,b) => a.some(word=>b.includes(word));
  const affinityGroups = [
    ['luffy','zoro','sanji','nami','robin','usopp','chopper','brook','franky','jinbe'],['luffy','ace','sabo'],['law','luffy','kid'],
    ['goku','vegeta','gohan','piccolo','trunks','gogeta','goten'],['goku','chichi'],['naruto','sasuke','sakura','kakashi'],['itachi','sasuke'],
    ['tanjiro','nezuko','zenitsu','inosuke'],['gojo','yuji','megumi','nobara','sukuna'],['eren','mikasa','armin','levi'],['gon','killua','kurapika','leorio'],
    ['deku','midoriya','bakugo','todoroki'],['light','ryuk','misa'],['denji','power','aki','makima']
  ];
  const palette = product => {
    const text = ` ${norm(`${product.title} ${product.variantTitle || ''} ${tags(product).join(' ')}`)} `;
    return [['black','noir','schwarz'],['white','blanc','weiss'],['red','rouge','rot'],['blue','bleu','blau'],['green','vert','grun'],['pink','rose','rosa'],['gray','grey','gris','grau'],['beige']].flatMap(group=>group.some(word=>text.includes(` ${word} `))?[group[0]]:[]);
  };
  const styles = product => {
    const text=` ${norm(`${product.title} ${product.variantTitle || ''} ${tags(product).join(' ')}`).replace(/\b(articulee?|articulable)\b/g,'articulated')} `;
    return ['chibi','nendoroid','funko','q posket','articulated'].filter(word=>text.includes(` ${word} `));
  };
  const height = product => {
    const matches=String(`${product.variantTitle || ''} ${product.title}`).matchAll(/\b(\d{1,3}(?:[.,]\d)?)\s*cm\b/gi);
    const sizes=[...matches].map(match=>Number(match[1].replace(',','.'))).filter(size=>size>=3 && size<=150);
    return [...new Set(sizes)].length===1?sizes[0]:null;
  };
  const compatibility = (source,target,sameCharacter) => {
    if(source===target && sameCharacter)return 0;
    if(source==='figure')return ({figure:75,lamp:50,cushion:43,plush:42,mug:38,poster:23,keychain:27,bag:30,headwear:25,jewelry:28})[target] || 0;
    if(family(source)==='clothing') {
      if(source===target)return ['top','layer','bottom','clothing'].includes(source)?41:20;
      return ({bag:70,headwear:68,jewelry:62,footwear:58,top:60,layer:58,bottom:62,clothing:42,keychain:27})[target] || 0;
    }
    if(family(source)==='decoration') {
      if(source===target)return 25;
      return ({lamp:72,poster:62,cushion:60,figure:55,mug:48,plush:44,decoration:54})[target] || 0;
    }
    return source!==target?({figure:52,lamp:48,poster:30,cushion:45,mug:48,bag:50,keychain:42,plush:45,jewelry:48,headwear:42})[target] || 0:20;
  };
  const tie = (source,id) => {
    let value=2166136261;
    for(const char of `${source}:${id}`)value=Math.imul(value^char.charCodeAt(0),16777619);
    return (value>>>0)/4294967296;
  };
  const rank = (candidates,source,cart,verifiedOnly=false) => {
    const origin=context(source,true),sourceKind=kind(source);
    if(!origin.universes.length || !sourceKind)return [];
    const ids=new Set([Number(source.id),...cart.items.map(item=>Number(item.product_id))]);
    const cartProfiles=cart.items.map(item=>({context:context({title:item.product_title,variantTitle:item.variant_title},true),category:kind(item)}));
    const unique=new Map();
    candidates.forEach(candidate=>{const old=unique.get(Number(candidate.id));unique.set(Number(candidate.id),{...old,...candidate,shopifyRelated:Boolean(old?.shopifyRelated||candidate.shopifyRelated)});});
    return [...unique.values()].flatMap(candidate=>{
      if(ids.has(Number(candidate.id)) || !candidate.available || !candidate.image || candidate.giftCard || candidate.requiresSellingPlan || candidate.variantsCount>250 || candidate.minimum>1 || candidate.increment>1 || (candidate.maximum != null && candidate.maximum < 1) || !Number.isFinite(candidate.price) || candidate.price<=0)return [];
      if(verifiedOnly && !candidate.resolved)return [];
      const target=context(candidate,candidate.resolved || !context(candidate).characters.length),category=kind(candidate);
      if(!category || !same(origin.universes,target.universes))return [];
      const sameCharacter=same(origin.characters,target.characters);
      const base=compatibility(sourceKind,category,sameCharacter);
      if(!base)return [];
      if(verifiedOnly && sourceKind==='figure' && category==='figure' && (!origin.characters.length || !target.characters.length))return [];
      if(cartProfiles.some(profile=>profile.category===category && same(profile.context.universes,target.universes) && same(profile.context.characters,target.characters)))return [];
      const aStyles=styles(source),bStyles=styles(candidate);
      if(sourceKind==='figure' && category==='figure' && aStyles.length && bStyles.length && !same(aStyles,bStyles))return [];
      const aHeight=height(source),bHeight=height(candidate);
      if(sourceKind==='figure' && category==='figure' && aHeight && bHeight && Math.max(aHeight,bHeight)/Math.min(aHeight,bHeight)>1.6)return [];
      const ratio=candidate.price/Math.max(Number(source.price)||1,1);
      const priceBonus=ratio>=.2 && ratio<=1.2?10:ratio<.2?0:-Math.min(42,20*Math.log2(ratio/1.2));
      const affinity=!sameCharacter && affinityGroups.some(group=>same(group,origin.characters) && same(group,target.characters));
      const closePair=!sameCharacter && [['zoro','sanji'],['zoro','luffy'],['goku','vegeta'],['naruto','sasuke'],['gon','killua'],['tanjiro','nezuko'],['eren','mikasa'],['gojo','yuji'],['denji','power']].some(pair=>same(pair,origin.characters) && same(pair,target.characters));
      const preference=Math.min(12,cartProfiles.filter(profile=>same(profile.context.universes,target.universes) && same(profile.context.characters,target.characters)).length*6);
      const score=base+(sameCharacter?20:0)+(closePair?18:affinity?10:0)+preference+priceBonus+(candidate.shopifyRelated?5:0)+(same(aStyles,bStyles)?10:0)+(same(palette(source),palette(candidate))?6:0)+(aHeight&&bHeight&&Math.abs(aHeight-bHeight)<=3?6:0)+tie(`${source.id}:${source.variantId}`,candidate.id);
      if(verifiedOnly && score<65)return [];
      return [{...candidate,score,category,sameCharacter,affinity}];
    }).sort((a,b)=>b.score-a.score);
  };
  const variantChoices = (product,source,eligible) => {
    let variants=(product.variants||[]).filter(eligible);
    if (product.hasOnlyDefaultVariant === true) return variants;
    if (product.hasOnlyDefaultVariant !== false) return [];
    const target=context(product),origin=context(source,true);
    const profiles=variants.map(variant=>({variant,characters:context({...product,variantTitle:variant.title},true).characters}));
    const named=variants.some(variant=>words(variant.title).length);
    if(named && target.characters.length) {
      const matching=profiles.filter(profile=>same(profile.characters,target.characters)).map(profile=>profile.variant);
      if(!matching.length)return [];
      variants=matching;
    } else if(named && origin.characters.length) {
      const matching=profiles.filter(profile=>kind(source)==='figure' && kind(product)==='figure'?!same(profile.characters,origin.characters):same(profile.characters,origin.characters)).map(profile=>profile.variant);
      if(matching.length)variants=matching;
    }
    return variants;
  };
  const queryGroups = source => family(kind(source))==='clothing' ? [
    ['sac','bag','tasche','casquette','cap','bonnet','bracelet','collier','halskette','armband','mutze'],['shirt','maillot','sweat','hoodie','veste','jacket','jacke','pantalon','hose','short'],['porte-cles','keychain','schlusselanhanger','goodies']
  ] : family(kind(source))==='decoration' ? [
    ['lampe','lamp','coussin','cushion','kissen','mug'],['figurine','figure','figur','statue'],['poster','banniere','banner','decoration','deko']
  ] : [['figurine','figure','figur','statue','statuette'],['lampe','lamp','poster','banniere','banner','coussin','cushion'],['mug','tasse','porte-cles','keychain','peluche','plush','sac','bag']];
  return {norm,context,kind,family,rank,variantChoices,queryGroups};
})();


  class SaikoProductDuo extends HTMLElement {
    static instances = new Set();
    static state = { busy: false, pending: null, recovering: false };
    static cache = new Map();

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try { this.config = JSON.parse(this.dataset.config); } catch { return; }
      this.lifecycle = new AbortController();
      this.cards = [];
      this.cart = { items: [] };
      this.selected = [Number(this.config.selectedId), 0];
      this.status = this.querySelector('[data-status]');
      this.offer = this.querySelector('[data-offer]');
      this.addButton = this.querySelector('[data-add]');
      this.recovery = this.querySelector('[data-recovery]');
      this.info = this.closest('product-info');
      this.form = this.info && document.getElementById(this.info.getAttribute('form'));
      SaikoProductDuo.instances.add(this);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-add]')) this.add();
        if (event.target.closest('[data-refresh]')) this.recover();
      }, { signal: this.lifecycle.signal });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-variant]');
        if (!select) return;
        const index = Number(select.dataset.index);
        if (index === 0) this.changeMain(Number(select.value));
        else { this.selected[1] = Number(select.value); this.message(''); this.update(); }
      }, { signal: this.lifecycle.signal });
      this.form?.addEventListener('variant:change', event => this.syncMain(event.detail?.variant), { signal: this.lifecycle.signal });
      this.form?.addEventListener('change', event => {
        if (event.target.name === 'selling_plan') this.update();
      }, { signal: this.lifecycle.signal });
      const bus = window.theme?.pubsub;
      if (bus) {
        this.unsubscribe = bus.subscribe(bus.PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.cart?.items) {
            this.cart = event.cart;
            if (this.completed && !this.partnerInCart()) { this.completed = false; this.message(''); }
            this.update();
            if (event.source !== 'saiko-product-duo') this.scheduleSelection();
          }
        });
        this.unsubscribeVariant = bus.subscribe(bus.PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data?.productId) === String(this.config.products[0].id) && String(event.data?.sectionId) === String(this.config.sectionId)) this.syncMain(event.data.variant);
        });
      }
      this.start();
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.nativeRequest?.abort();
      this.selectionRequest?.abort();
      clearTimeout(this.selectionTimer);
      this.unsubscribe?.();
      this.unsubscribeVariant?.();
      SaikoProductDuo.instances.delete(this);
      this.initialized = false;
    }

    endpoint(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    productEndpoint(product) { return this.endpoint(`products/${encodeURIComponent(product.handle)}.js`); }
    text(key) { return this.config.messages[key] || ''; }

    money(cents) {
      if (window.theme?.Currency?.formatMoney) {
        const holder = document.createElement('span');
        holder.innerHTML = window.theme.Currency.formatMoney(cents, this.config.moneyFormat);
        return holder.textContent;
      }
      return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(cents / 100);
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const external = options.signal;
      const abort = () => controller.abort();
      if (external?.aborted) abort();
      external?.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(abort, options.method === 'POST' ? 20000 : 10000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        if (!response.ok) { const error = new Error('Request failed'); error.status = response.status; throw error; }
        return options.asText ? await response.text() : await response.json();
      } finally { clearTimeout(timer); external?.removeEventListener('abort', abort); }
    }

    mergeProduct(index, fresh) {
      const old = this.config.products[index];
      const rules = new Map(old.variants.map(variant => [Number(variant.id), variant.quantity_rule]));
      if (Number(fresh.id) !== Number(old.id) || fresh.requires_selling_plan || !Array.isArray(fresh.variants)) throw new Error('Product unavailable');
      old.variants = fresh.variants.map(variant => ({ ...variant, quantity_rule: variant.quantity_rule || rules.get(Number(variant.id)) }));
      if (index === 1 && old.allowedVariantIds) old.variants = old.variants.filter(variant => old.allowedVariantIds.includes(Number(variant.id)));
      old.image = typeof fresh.featured_image === 'string' ? fresh.featured_image : old.image;
      if (fresh.title) old.title = fresh.title;
      return old;
    }

    async start() {
      try {
        const [cart, main] = await Promise.all([
          this.request(this.endpoint('cart.js'), { signal: this.lifecycle.signal }),
          this.request(this.productEndpoint(this.config.products[0]), { signal: this.lifecycle.signal })
        ]);
        if (!this.isConnected) return;
        this.cart = cart;
        this.mergeProduct(0, main);
        if (!this.config.products[0].variants.some(eligible)) return;
        const mainId = Number(this.form?.querySelector('[name="id"]')?.value);
        if (mainId) this.selected[0] = mainId;
        this.initialReady = true;
        await this.selectPartner();
        if (SaikoProductDuo.state.pending && !SaikoProductDuo.state.busy) this.recover();
      } catch { this.hidden = true; }
      finally { this.started = true; }
    }

    source() {
      const main = this.config.products[0], variant = this.variant(0);
      return { ...main, variantId: variant?.id, variantTitle: variant?.title, price: Number(variant?.price) };
    }

    async cached(url, options = {}) {
      const cache = SaikoProductDuo.cache, key = `${this.config.currency}:${url}`;
      const old = cache.get(key);
      if (old && Date.now() - old.time < 45000) return old.value;
      const value = await this.request(url, options);
      if (cache.size >= 24) cache.delete(cache.keys().next().value);
      cache.set(key, { time: Date.now(), value });
      return value;
    }

    async productWithMetadata(candidate, signal) {
      const product = await this.cached(this.productEndpoint(candidate), { signal });
      if (Number(product.id) !== Number(candidate.id)) throw new Error('Product mismatch');
      if (typeof candidate.hasOnlyDefaultVariant === 'boolean') {
        return { ...product, hasOnlyDefaultVariant: candidate.hasOnlyDefaultVariant };
      }
      const url = new URL(this.endpoint(`products/${encodeURIComponent(product.handle || candidate.handle)}`), location.origin);
      url.searchParams.set('section_id', this.config.dataSection);
      const html = await this.cached(url.toString(), { asText: true, signal });
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const node = parsed.querySelector('[data-saiko-product-meta]');
      const metadata = JSON.parse(node?.dataset.saikoProductMeta || 'null');
      if (!metadata || Number(metadata.id) !== Number(product.id) || typeof metadata.hasOnlyDefaultVariant !== 'boolean') {
        throw new Error('Product metadata unavailable');
      }
      return { ...product, hasOnlyDefaultVariant: metadata.hasOnlyDefaultVariant };
    }

    async candidates(source, signal) {
      const context = DuoEngine.context(source, true);
      if (!context.query || !context.universes.length) return [];
      const anime = context.query.replace(/["\\]/g, ' ').trim();
      const queries = DuoEngine.queryGroups(source).map(group => `"${anime}" AND (${group.map(word => `title:${word}*`).join(' OR ')})`);
      if (context.characters.length) queries.push(`"${anime}" AND (${context.characters.slice(0, 3).map(word => `title:${word}*`).join(' OR ')})`);
      const searches = queries.map(async query => {
        const url = new URL(this.config.searchUrl, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'hide');
        url.searchParams.set('sort_by', 'relevance');
        url.searchParams.set('section_id', this.config.dataSection);
        const html = await this.cached(url.toString(), { asText: true, signal });
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        return [...parsed.querySelectorAll('[data-saiko-candidate]')].flatMap(node => {
          try { return [JSON.parse(node.dataset.saikoCandidate)]; } catch { return []; }
        });
      });
      const related = async () => {
        const url = new URL(this.endpoint('recommendations/products.json'), location.origin);
        url.searchParams.set('product_id', source.id);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
        const result = await this.cached(url.toString(), { signal });
        return (result.products || []).map(product => {
          const variant = (product.variants || []).find(eligible);
          return { ...product, type: product.type, image: product.featured_image, available: Boolean(variant), price: Number(variant?.price), variantId: variant?.id, variantTitle: variant?.title, variantsCount: product.variants_count || product.variants?.length, requiresSellingPlan: product.requires_selling_plan, giftCard: product.gift_card, shopifyRelated: true };
        });
      };
      const results = await Promise.allSettled([...searches, related()]);
      return results.flatMap(result => result.status === 'fulfilled' ? result.value : []);
    }

    scheduleSelection() {
      if (!this.initialReady || this.completed || SaikoProductDuo.state.busy || SaikoProductDuo.state.pending) return;
      this.selectionRequest?.abort();
      clearTimeout(this.selectionTimer);
      this.selecting = true;
      this.update();
      this.selectionTimer = setTimeout(() => this.selectPartner(), 160);
    }

    async selectPartner() {
      if (!this.initialReady || this.completed || SaikoProductDuo.state.busy || SaikoProductDuo.state.pending) return;
      this.selectionRequest?.abort();
      const controller = new AbortController();
      this.selectionRequest = controller;
      const source = this.source(), previous = this.config.products[1];
      this.selecting = true;
      this.update();
      try {
        if (!eligible(this.variant(0))) throw new Error('Unavailable source');
        const candidates = await this.candidates(source, controller.signal);
        if (controller.signal.aborted || !this.isConnected) return;
        const ordered = DuoEngine.rank(candidates, source, this.cart);
        const diverse = ordered.filter((item, index, all) => all.findIndex(other => other.category === item.category) === index).slice(0, 3);
        const ranked = [...new Map([...ordered.slice(0, 5), ...diverse, ...ordered].map(item => [item.id, item])).values()].slice(0, 8);
        const verified = [];
        for (let offset = 0; offset < ranked.length; offset += 4) {
          const batch = await Promise.allSettled(ranked.slice(offset, offset + 4).map(async candidate => {
            const product = await this.productWithMetadata(candidate, controller.signal);
            if (Number(product.id) !== Number(candidate.id) || product.requires_selling_plan || product.gift_card || product.variants_count > 250 || product.variants?.length >= 250) return null;
            const variants = DuoEngine.variantChoices(product, source, eligible).filter(variant => DuoEngine.rank([{ ...candidate, ...product, resolved: true, available: true, variantId: variant.id, variantTitle: variant.title, price: Number(variant.price), image: variant.featured_image?.src || candidate.image }], source, this.cart, true).length);
            if (!variants.length) return null;
            const variant = variants.find(item => Number(item.id) === this.selected[1] && Number(candidate.id) === Number(previous?.id)) || variants[0];
            return { ...candidate, title: product.title, type: product.type || candidate.type, tags: product.tags || candidate.tags, url: product.url || candidate.url, variants, allowedVariantIds: variants.map(item => Number(item.id)), defaultOnly: variants.length === 1, hasOnlyDefaultVariant: product.hasOnlyDefaultVariant, resolved: true, available: true, variantId: variant.id, variantTitle: variant.title, price: Number(variant.price), image: variant.featured_image?.src || candidate.image };
          }));
          verified.push(...batch.flatMap(result => result.status === 'fulfilled' && result.value ? [result.value] : []));
          if (controller.signal.aborted || !this.isConnected) return;
        }
        const partner = DuoEngine.rank(verified, source, this.cart, true)[0];
        if (!partner) throw new Error('No relevant match');
        const preserve = Number(partner.id) === Number(previous?.id) && partner.allowedVariantIds.includes(this.selected[1]);
        this.config.products = [this.config.products[0], partner];
        this.selected[1] = preserve ? this.selected[1] : partner.defaultOnly ? partner.variantId : 0;
        this.mountCards();
        this.loaded = true;
      } catch {
        if (!controller.signal.aborted) { this.loaded = false; this.hidden = true; }
      } finally {
        if (this.selectionRequest === controller && !controller.signal.aborted) { this.selecting = false; this.update(); }
      }
    }

    mountCards() {
      const container = this.querySelector('[data-cards]');
      container.replaceChildren();
      this.cards = this.config.products.map((product, index) => {
        const card = this.querySelector('[data-card]').content.firstElementChild.cloneNode(true);
        card.querySelector('[data-title]').textContent = product.title.split(/\s*[|｜]\s*/)[0];
        card.querySelector('[data-title]').title = product.title;
        card.querySelector('[data-image]').alt = product.title;
        card.querySelector('[data-choice-label]').textContent = this.text('options');
        card.querySelector('[data-quantity]').textContent = this.text('one_each');
        card.querySelector('[data-in-cart]').textContent = this.text('in_cart');
        const select = card.querySelector('[data-variant]');
        select.dataset.index = index;
        select.setAttribute('aria-label', `${this.text('options')} — ${product.title}`);
        container.append(card);
        return card;
      });
      this.populateChoices();
    }

    populateChoices() {
      this.cards.forEach((card, index) => {
        const product = this.config.products[index];
        const select = card.querySelector('[data-variant]');
        select.replaceChildren();
        const placeholder = new Option(this.text('choose'), '');
        select.add(placeholder);
        product.variants.forEach(variant => {
          const option = new Option(`${variant.title}${eligible(variant) ? '' : ` — ${this.text('unavailable_short')}`}`, variant.id);
          option.disabled = !eligible(variant);
          select.add(option);
        });
        card.querySelector('[data-choice]').hidden = product.defaultOnly;
      });
    }

    variant(index) { return this.config.products[index]?.variants.find(variant => Number(variant.id) === this.selected[index]); }
    partnerInCart() { return this.cart.items.some(item => Number(item.product_id) === Number(this.config.products[1]?.id)); }
    mainInCart() {
      const properties = this.properties(false);
      if (properties === null) return false;
      const clean = value => Object.entries(value || {}).filter(([, entry]) => entry !== '').sort(([a], [b]) => a.localeCompare(b));
      const expected = JSON.stringify(clean(properties));
      return this.cart.items.some(item => Number(item.variant_id) === this.selected[0] && !item.selling_plan_allocation && JSON.stringify(clean(item.properties)) === expected);
    }
    planSelected() { return Boolean(this.form?.querySelector('[name="selling_plan"]')?.value); }

    update() {
      if (!this.loaded || !this.isConnected) return;
      const state = SaikoProductDuo.state;
      const main = this.variant(0);
      const partner = this.variant(1);
      const mainInCart = this.mainInCart();
      const ready = eligible(main) && eligible(partner) && !this.planSelected();
      let total = 0;
      this.cards.forEach((card, index) => {
        const product = this.config.products[index];
        const selected = this.variant(index);
        const fallback = product.variants.filter(eligible).sort((a, b) => a.price - b.price)[0];
        const variant = selected || fallback;
        if (!variant) return;
        const price = Number(variant.price);
        if (index || !mainInCart) total += price;
        card.querySelector('[data-price]').textContent = (selected ? '' : this.text('from') + ' ') + this.money(price);
        const onSale = selected && Number(variant.compare_at_price) > price;
        const compare = card.querySelector('[data-compare]');
        compare.hidden = !onSale;
        compare.textContent = onSale ? this.money(Number(variant.compare_at_price)) : '';
        compare.setAttribute('aria-label', `${this.text('regular_price')} ${compare.textContent}`);
        card.querySelector('[data-price-label]').textContent = onSale ? this.text('sale_price') : this.text('regular_price');
        card.querySelector('[data-image]').src = variant.featured_image?.src || product.image;
        const url = new URL(product.url, location.origin);
        if (selected) url.searchParams.set('variant', selected.id);
        card.querySelectorAll('[data-link]').forEach(link => { link.href = url.pathname + url.search; });
        const select = card.querySelector('[data-variant]');
        select.value = selected ? String(selected.id) : '';
        select.disabled = state.busy || Boolean(state.pending) || this.nativeBusy || this.selecting;
        card.querySelector('[data-in-cart]').hidden = index !== 0 || !mainInCart;
      });
      this.querySelector('[data-total-label]').textContent = this.text(mainInCart ? 'total_addition' : 'total');
      this.querySelector('[data-total]').textContent = (ready ? '' : this.text('from') + ' ') + this.money(total);
      this.addButton.textContent = this.text(state.busy ? 'adding' : ready ? (mainInCart ? 'add_complement' : 'add') : 'choose');
      this.addButton.disabled = !ready || state.busy || Boolean(state.pending) || this.nativeBusy || this.selecting;
      this.addButton.setAttribute('aria-busy', String(Boolean(state.busy || this.nativeBusy)));
      this.offer.hidden = this.partnerInCart() || !eligible(main) || this.planSelected() || this.completed || this.selecting;
      this.hidden = this.offer.hidden && this.status.hidden;
    }

    syncMain(variant) {
      if (!variant) { this.selected[0] = 0; this.update(); return; }
      if (!this.applyingNative) this.nativeRequest?.abort();
      const changed = this.selected[0] !== Number(variant.id);
      this.selected[0] = Number(variant.id);
      const current = this.config.products[0].variants.find(item => Number(item.id) === Number(variant.id));
      if (current) Object.assign(current, variant);
      this.update();
      if (changed) this.scheduleSelection();
    }

    async changeMain(id) {
      if (!id || id === this.selected[0]) { this.update(); return; }
      if (typeof this.info?.handleUpdateProductInfo !== 'function') {
        this.message('choose_on_page', true);
        this.update();
        return;
      }
      this.nativeRequest?.abort();
      this.info.renderAbortController?.abort();
      const controller = new AbortController();
      this.nativeRequest = controller;
      this.nativeBusy = true;
      this.update();
      try {
        const url = new URL(this.config.products[0].url, location.origin);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', this.config.sectionId);
        const html = await this.request(url, { asText: true, signal: controller.signal });
        if (!this.isConnected || controller.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const selected = parsed.querySelector('[data-selected-variant]');
        if (!selected || Number(JSON.parse(selected.textContent)?.id) !== id) throw new Error('Variant mismatch');
        this.applyingNative = true;
        this.info.handleUpdateProductInfo()(parsed, url.toString());
        this.selected[0] = id;
        this.message('');
      } catch (error) {
        if (!controller.signal.aborted) this.message('variant_error', true);
      } finally {
        this.applyingNative = false;
        this.nativeBusy = false;
        this.update();
      }
    }

    message(key, error = false, recovery = false) {
      this.status.textContent = key ? this.text(key) : '';
      this.status.hidden = !key;
      this.status.toggleAttribute('data-error', error);
      this.recovery.hidden = !recovery;
      if (key) this.hidden = false;
    }

    sections() {
      const drawerId = document.querySelector('cart-drawer')?.dataset.sectionId;
      const sections = drawerId ? [drawerId] : [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
      return [...new Set(sections.filter(Boolean))].slice(0, 5);
    }

    async renderCart(cart, sections = {}, open = false) {
      const drawer = document.querySelector('cart-drawer');
      const id = drawer?.dataset.sectionId;
      const bus = window.theme?.pubsub;
      if (!id || !bus) throw new Error('Cart unavailable');
      const valid = html => typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').getElementById(`MiniCart-${id}`);
      sections = sections || {};
      if (!valid(sections[id])) {
        const url = new URL(location.pathname, location.origin);
        url.searchParams.set('sections', this.sections().join(','));
        sections = { ...sections, ...await this.request(url) };
      }
      if (!valid(sections[id])) throw new Error('Cart markup unavailable');
      this.cart = cart;
      cart.sections = sections;
      bus.publish(bus.PUB_SUB_EVENTS.cartUpdate, { source: 'saiko-product-duo', cart });
      if (open && typeof drawer.show === 'function') drawer.show(this.addButton);
    }

    properties(validate = true) {
      if (!this.form) return {};
      if (validate && !this.form.reportValidity()) return null;
      const properties = {};
      for (const [name, value] of new FormData(this.form).entries()) {
        const match = /^properties\[(.+)\]$/.exec(name);
        if (!match) continue;
        if (value instanceof File) { if (value.size) return null; }
        else properties[match[1]] = value;
      }
      return properties;
    }

    async add() {
      const state = SaikoProductDuo.state;
      if (!this.loaded || this.addButton.disabled || state.busy || state.pending) return;
      if (customElements.get('saiko-cart-complement')?.state?.busy || this.form?.querySelector('[type="submit"][aria-busy="true"]')) return;
      const properties = this.properties();
      if (properties === null) { this.message('form_error', true); return; }
      state.busy = true;
      SaikoProductDuo.instances.forEach(instance => instance.update());
      const chosen = [...this.selected];
      const shownPrices = chosen.map((id, index) => Number(this.variant(index)?.price));
      const wasMainInCart = this.mainInCart();
      let mutationStarted = false;
      try {
        const [cart, ...products] = await Promise.all([
          this.request(this.endpoint('cart.js')),
          ...this.config.products.map(product => this.request(this.productEndpoint(product)))
        ]);
        if (!this.isConnected || chosen.some((id, index) => id !== this.selected[index]) || this.planSelected()) return;
        this.cart = cart;
        products.forEach((product, index) => this.mergeProduct(index, product));
        this.populateChoices();
        if (this.partnerInCart()) { this.message('already_added'); await this.renderCart(cart, {}, true); return; }
        if (chosen.some((id, index) => !eligible(this.variant(index)))) { this.message('unavailable', true); return; }
        if (chosen.some((id, index) => Number(this.variant(index).price) !== shownPrices[index]) || wasMainInCart !== this.mainInCart()) {
          this.message('price_changed');
          return;
        }
        const items = [{ id: chosen[1], quantity: 1, properties: { _saiko_upsell: 'Duo' } }];
        if (!this.mainInCart()) items.unshift({ id: chosen[0], quantity: 1, properties });
        state.pending = {
          owner: this.config.products[0].id,
          items,
          before: items.map(item => quantity(cart, item.id)),
          knownSuccess: false,
          definiteError: false
        };
        mutationStarted = true;
        const response = await this.request(this.endpoint('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: this.sections(), sections_url: location.pathname })
        });
        if (response.status) { const error = new Error('Add failed'); error.status = response.status; throw error; }
        state.pending.knownSuccess = true;
        const updated = await this.request(this.endpoint('cart.js'));
        if (!state.pending.items.every((item, index) => quantity(updated, item.id) >= state.pending.before[index] + item.quantity)) throw new Error('Cart confirmation incomplete');
        await this.renderCart(updated, response.sections, true);
        state.pending = null;
        this.completed = true;
        this.message('added');
      } catch (error) {
        if (mutationStarted) {
          state.pending.definiteError = Boolean(error.status && error.status >= 400 && error.status < 500 && error.status !== 408);
          this.message('checking', false, true);
          await this.recover(true);
        } else this.message('error', true);
      } finally {
        state.busy = false;
        SaikoProductDuo.instances.forEach(instance => instance.update());
      }
    }

    async recover(fromAdd = false) {
      const state = SaikoProductDuo.state;
      if (state.recovering || !state.pending || (state.busy && !fromAdd)) return;
      state.recovering = true;
      const refresh = this.querySelector('[data-refresh]');
      refresh.disabled = true;
      try {
        const pending = state.pending;
        const cart = await this.request(this.endpoint('cart.js'));
        const complete = pending.items.every((item, index) => quantity(cart, item.id) >= pending.before[index] + item.quantity);
        const changed = pending.items.some((item, index) => quantity(cart, item.id) > pending.before[index]);
        await this.renderCart(cart, {}, complete || changed);
        if (complete) {
          state.pending = null;
          this.completed = true;
          this.message('added');
        } else if (pending.definiteError && !changed && !pending.knownSuccess) {
          state.pending = null;
          this.message('unavailable', true);
        } else this.message(changed ? 'partial' : 'uncertain', true, true);
      } catch { this.message(state.pending?.knownSuccess ? 'refresh_needed' : 'uncertain', true, true); }
      finally {
        state.recovering = false;
        refresh.disabled = false;
        SaikoProductDuo.instances.forEach(instance => instance.update());
      }
    }
  }

  customElements.define('saiko-product-duo', SaikoProductDuo);
})();
  } catch(e) { console.error(e); }
})();

})();
